/** @file Checks the inlined sector tables of a bundle puppet: four arrays of one length, valid tile indices. */
import type { BundleError } from '@zilo/pose3d-export/check/bundleError';
import type { ExportPuppet } from '@zilo/pose3d-export/types/bundle';

/** True when `t` has `thresholds`, `tile`, `flip`, `sideBack` arrays of one length >= 1 and integer tiles >= -1. */
function wellFormed(t: unknown): boolean {
  if (typeof t !== 'object' || t === null) return false;
  const { thresholds, tile, flip, sideBack } = t as Record<string, unknown>;
  const lists = [thresholds, tile, flip, sideBack];
  if (!lists.every(Array.isArray)) return false;
  const n = (thresholds as unknown[]).length;
  return n >= 1 && lists.every((l) => (l as unknown[]).length === n)
    && (tile as unknown[]).every((i) => Number.isInteger(i) && (i as number) >= -1)
    && (thresholds as unknown[]).every((x) => typeof x === 'number' && Number.isFinite(x));
}

/** One `BUNDLE_FORMAT` per malformed table at `/puppet/tables/<id>`, and the ids of those tables. */
export function checkBundleTables(puppet: ExportPuppet): { errors: BundleError[]; bad: Set<string> } {
  const errors: BundleError[] = [];
  const bad = new Set<string>();
  for (const [id, table] of Object.entries(puppet.tables)) {
    if (wellFormed(table)) continue;
    bad.add(id);
    errors.push({ code: 'BUNDLE_FORMAT', path: `/puppet/tables/${id}`, message: `table ${id} needs thresholds, tile, flip and sideBack of one length` });
  }
  return { errors, bad };
}
